/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from "rxjs";
import {VendorTagDtoModel} from "@well/domain";
import { AbstractResourceService, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';

@Injectable({
  providedIn: 'root'
})
export class VendorTagResourceService extends AbstractResourceService<any,
  any,
  any,
  any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('vendorTagUrl'),
      undefined,
      undefined
    );
  }

  findAllVendorTags(query?: any,
          additionalParams?: any): Observable<JsonApiResource<VendorTagDtoModel[], any>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []).toString();

    return this.httpClient?.get(`${this.url}/list${queryString}`,{headers: this.headers}).pipe(this.mapToListOfObjects());
  }
}
